import { createStore } from 'vuex'
import 'es6-promise/auto'

const store = createStore({
  state () {
    return {

    }
  },
  mutations: {

  },
  actions: {

  },
  getters: {

  }
})

export default store
